var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-separator',{attrs:{"color":_vm.color,"spaced":_vm.spaced,"vertical":_vm.vertical}})}
var staticRenderFns = []

export { render, staticRenderFns }